import { render, staticRenderFns } from "./CandidateLanguageInfo.vue?vue&type=template&id=497639f7"
import script from "./CandidateLanguageInfo.vue?vue&type=script&lang=js"
export * from "./CandidateLanguageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports